import * as React from "react";

import SearchStatus from "../searchStatus";
import ResultCard from "./ResultCard";
import {
  ScrollableContainer,
  ListContainer,
  SpinnerWrapper,
  LoadingSpinner,
  NoResultsContainer,
  StyledGhostly,
  Message,
} from "./styled";

const SearchResults = ({
  searchStatus,
  searchResults,
  menuPortalTarget,
  onCustomerSelected,
}) => {
  return (
    <ScrollableContainer>
      {searchStatus === SearchStatus.LOADING && (
        <SpinnerWrapper>
          <LoadingSpinner />
        </SpinnerWrapper>
      )}
      {searchStatus === SearchStatus.SHOW_RESULTS && (
        <ListContainer>
          {searchResults.map((customerData, index) => (
            <ResultCard
              key={`${customerData?.id}-${index}`}
              customerData={customerData}
              menuPortalTarget={menuPortalTarget}
              onCustomerSelected={onCustomerSelected}
            />
          ))}
        </ListContainer>
      )}
      {searchStatus === SearchStatus.NO_RESULTS && (
        <NoResultsContainer>
          <StyledGhostly />
          <Message size={"md"} weight={"attention"}>
            No results found.
          </Message>
        </NoResultsContainer>
      )}
    </ScrollableContainer>
  );
};

export default SearchResults;
